import React from 'react';
import { motion } from 'framer-motion';
import TopBar from '../components/TopBar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import Award from '../components/Award';
import {
  aboutStats,
  galleryImages,
  videoHighlights,
} from '../data/siteContent';
import heroImage from '../images/slider.jpg';
import doctorImage from '../images/logo_.png';

const About = () => {
  return (
    <div className="about-page page-load-shell">
      <SEO
        title="About Uttam Diabetes Care | Diabetes Doctor in Patna Bihar"
        description="Learn about Uttam Diabetes Care & Research Center, Dr. Santosh Kumar, diabetes care in Patna, kidney wellness support, and Hindi-friendly patient consultation."
        keywords="about diabetes clinic Patna, Dr Santosh Kumar Patna, diabetes doctor Bihar, kidney wellness support Patna, Hindi diabetes consultation"
      />
      <TopBar />
      <Navbar />

      <section className="hero-section">
        <div className="hero-image">
          <img src={heroImage} alt="About Uttam Diabetes Care" />
        </div>
        <div className="hero-overlay">
          <motion.div
            className="hero-content"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>About Us</h1>
            <p>Trusted diabetes care in Patna with Hindi-friendly guidance, kidney wellness support, and long-term patient follow-up</p>
          </motion.div>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <motion.div
            className="about-section"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="section-kicker">Who we are</span>
            <h2>About Dr. Santosh Kumar, Diabetes Care in Patna, and the Patient Support Model</h2>
            <p>
              Uttam Diabetes Care & Research Center is built around structured consultation, disciplined
              follow-up, and practical support for patients dealing with diabetes, insulin-related concerns,
              and kidney wellness issues. The aim is to make long-term care easier to understand and easier
              to continue.
            </p>
            <p>
              Dr. Santosh Kumar, MD, Gold Medalist, is presented across the project as the lead physician
              with more than 20 years of experience. The clinic’s approach emphasizes professional guidance,
              patient education, and family involvement where ongoing care is needed.
            </p>
            <p className="intro-hindi">
              हिंदी बोलने वाले मरीजों के लिए उपचार की प्रक्रिया, रिपोर्ट की समझ, खान-पान की सलाह और
              फॉलो-अप की जानकारी सरल तरीके से दी जाती है, ताकि मरीज बिना भ्रम के आगे बढ़ सके।
            </p>
          </motion.div>

          <motion.div
            className="about-cards"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            {aboutStats.map((stat) => (
              <div key={stat.label} className="about-card">
                <h3>{stat.value}</h3>
                <p>{stat.label}</p>
              </div>
            ))}
          </motion.div>

          <motion.div
            className="profile-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="profile-image profile-image-real">
              <img src={doctorImage} alt="Dr. Santosh Kumar" />
            </div>
            <div className="profile-info">
              <span className="section-kicker">What patients value</span>
              <h2>Professional care that feels understandable</h2>
              <p className="qualification">MD, Gold Medalist | Hindi-friendly consultation support</p>
              <div className="profile-description">
                <p>
                  Families often need more than a prescription. They need clarity about what reports mean,
                  what lifestyle adjustments matter, when to return, and what to monitor next. This page
                  reflects that patient-first direction across the project.
                </p>
                <p className="profile-hindi">
                  सही समझ, नियमित अनुशासन और समय पर सलाह, लंबे समय तक चलने वाले उपचार को अधिक प्रभावी
                  और भरोसेमंद बनाते हैं।
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="image-gallery"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <span className="section-kicker">Real photos</span>
            <h2>Clinic & Consultation Gallery</h2>
            <div className="gallery-grid">
              {galleryImages.map((item, index) => (
                <div key={`${item.alt}-${index}`} className="gallery-item">
                  <img src={item.src} alt={item.alt} />
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            className="video-gallery"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <span className="section-kicker">Real videos</span>
            <h2>Video Highlights</h2>
            <div className="video-showcase-grid">
              {videoHighlights.map((video) => (
                <div key={video.id} className="video-showcase-card">
                  <video className="showcase-video" controls preload="metadata" poster={video.poster}>
                    <source src={video.src} type="video/mp4" />
                  </video>
                  <p className="video-title">{video.title}</p>
                </div>
              ))}
            </div>
          </motion.div>

        </div>
        <Award />
      </section>

      <Footer />
    </div>
  );
};

export default About;
